import { render, staticRenderFns } from "./MiniTestCard.vue?vue&type=template&id=7ff5968a"
import script from "./MiniTestCard.vue?vue&type=script&lang=js"
export * from "./MiniTestCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports